import type { Category } from "../types";
import type { Blocklist } from "./blocklist";
import type { BlockedItems } from "./blocked-items";

/** Attribute contract for markup-level tagging — the leak-free way to hold back a static tag. */
export const CATEGORY_ATTR = "data-ck-category";
export const SRC_ATTR = "data-ck-src";
export const ALLOW_ATTR = "data-ck-allow";
export const PLACEHOLDER_ATTR = "data-ck-placeholder";
export const BLOCKED_SCRIPT_TYPE = "text/plain";

export interface BlockingContext {
  blocklist: Blocklist;
  items: BlockedItems;
  isGranted(category: Category): boolean;
  debug: boolean;
}

export function log(context: BlockingContext, ...args: unknown[]): void {
  if (context.debug) console.info("[consentkit]", ...args);
}

/**
 * A category declared in markup. Self-declaring as "necessary" is ignored on purpose —
 * otherwise any injected third-party tag could opt itself out of blocking.
 */
export function readTaggedCategory(element: Element): Category | null {
  const raw = element.getAttribute(CATEGORY_ATTR);
  if (!raw) return null;
  const value = raw.trim().toLowerCase();
  if (value === "functional" || value === "analytics" || value === "marketing") return value;
  return null;
}

export function isExplicitlyAllowed(element: Element): boolean {
  return element.hasAttribute(ALLOW_ATTR);
}
